
import { defineComponent, onMounted } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import FlowRegisterEvents from '@/components/block/FlowRegisterEvents.vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import Button from '@/components/elements/Button.vue'
import TextLink from '@/components/elements/TextLink.vue'

export default defineComponent({
  name: 'RegisterEventsThanks',

  components: {
    HeadingLv2,
    FlowRegisterEvents,
    GoalButtons,
    Button,
    TextLink
  },

  setup() {
    const appUrl = process.env.VUE_APP_URL

    onMounted(() => {
      localStorage.removeItem('userSelection')
      localStorage.removeItem('registerEvent')
    })

    return { appUrl }
  }
})
